module.exports = __webpack_public_path__ + "media/images/emblems/Walperswil-coat_of_arms-537e07c60dd3ae2a85b06dab97163ca0.svg";